import { render, staticRenderFns } from "./PanoramaConventionRow.vue?vue&type=template&id=45b36431&scoped=true"
import script from "./PanoramaConventionRow.vue?vue&type=script&lang=js"
export * from "./PanoramaConventionRow.vue?vue&type=script&lang=js"
import style0 from "./PanoramaConventionRow.vue?vue&type=style&index=0&id=45b36431&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b36431",
  null
  
)

export default component.exports